module.exports = {
  RAILS_API_URL: 'https://aideal-api.appier.com',
  RAILS_API_PORT: 443,
  FACADE_API_URL: 'https://facade.zenclerk.com',
  FACADE_API_PORT: 443,
  ZC_APIKEY: 'emin-zc',
  ZC_TAG_EVENT_PREFIX: 'zc',
  AIDEAL_URL: 'https://aideal-app.appier.com',
  GRAPHQL_URL_APP: 'https://aideal-graphql.appier.com/graphql',
  GRAPHQL_URL_MASTER: 'https://aideal-graphql.appier.com/mgraphql',
  SENTRY_DSN: 'https://8436c8f60721c27e1e1f02edeaa61847@sentry.zenclerk.com/13',
  CONFIG_ENV: 'production',
  ENABLE_AUTH0: true,
};



// WEBPACK FOOTER //
// ./src/env.js